// The people and agents a search can scope to (`in:@x`, `from:@x`, the People section): one list
// for the header bar and the mobile overlay, so a name resolves the same way on both.
import { authState, cyboState, workspaceState } from "$lib/state/app.svelte.js";
import { memberEmailLocalPart } from "$lib/member-email";
import { agentDisplayName } from "$lib/agent-display.js";
import { isMe } from "$lib/session-scope.js";
import { sessionDisplayName } from "$lib/state/session-alias.svelte.js";
import { agentIdentityTargets, type PersonCandidate } from "./global-search.js";

export function searchPeopleCandidates(): PersonCandidate[] {
  const out: PersonCandidate[] = [];
  for (const m of workspaceState.members) {
    if (isMe(m.userId, authState.user)) continue;
    out.push({
      id: m.userId,
      kind: "dm",
      name: m.name ?? authState.getMemberName(m.userId) ?? (memberEmailLocalPart(m) || "User"),
      email: m.email || null,
    });
  }
  for (const a of agentIdentityTargets(
    workspaceState.agents,
    cyboState.list,
    (x) => sessionDisplayName(x, cyboState.list),
    (x) => agentDisplayName(x, cyboState.list),
  )) {
    out.push({ ...a, kind: "agent", email: null });
  }
  return out;
}
